"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _Checkbox2 = _interopRequireDefault(require("./Checkbox.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Checkbox = _ref => {
  let {
    className = "",
    checked = false,
    error,
    errorMessage,
    label,
    name,
    required,
    setChecked,
    value,
    CheckboxProps,
    FormControlProps,
    FormControlLabelProps
  } = _ref;
  const css = (0, _Checkbox2.default)();
  const [localValue, setLocalValue] = (0, _react.useState)(checked);
  const isControlledField = setChecked ? true : false;
  const fieldLabel = required && typeof label === "string" ? label + " *" : label;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.checkbox, "mco-form-checkbox", {
      [css.checkboxError]: error
    }, {
      "mco-form-checkbox--error": error
    }, className)
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    required: required,
    error: error,
    component: "fieldset"
  }, FormControlProps), /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, _extends({
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
      checked: !isControlledField ? localValue : checked,
      "data-required": required,
      onChange: e => {
        if (!isControlledField) {
          setLocalValue(e.target.checked);
        } else {
          setChecked(e.target.checked);
        }
      },
      name: name,
      value: value
    }, CheckboxProps)),
    label: typeof label === "string" ? /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: fieldLabel
      }
    }) : label
  }, FormControlLabelProps)), error && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, errorMessage)));
};
var _default = exports.default = Checkbox;